document.addEventListener('DOMContentLoaded', function () {
  const maxSamples = 3;
  const messageBox = document.getElementById('samples-meassge-box');

  function showMessage(msg, type = 'info') {
    if (messageBox) {
      messageBox.innerHTML = `<p class="${type}"><strong>${msg}</strong></p>`;
    }
  }

  function updateSelectedSampleLabels() {
    const fieldset = document.querySelector('fieldset.fieldset-Color');
    if (!fieldset) return;

    const labelSpan = fieldset.querySelector('legend .selected-option-value');
    if (!labelSpan) return;

    const selectedLabels = Array.from(document.querySelectorAll('label.variant-option-Color.is-selected'));
    const selectedValues = selectedLabels.map(label => {
      const inner = label.querySelector('.swatch-input__label-inner');
      return inner ? inner.textContent.trim() : label.textContent.trim();
    });

    labelSpan.textContent = selectedValues.join(', ') || 'None';
  }

  function updateSelectedMaterialLabel() {
    const fieldset = document.querySelector('fieldset.fieldset-Material');
    if (!fieldset) return;

    const labelSpan = fieldset.querySelector('legend .selected-option-value');
    if (!labelSpan) return;

    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    if (!checkedInput) {
      labelSpan.textContent = 'None';
      return;
    }

    const label = fieldset.querySelector(`label[for="${checkedInput.id}"]`);
    if (!label) return;

    const inner = label.querySelector('.swatch-input__label-inner');
    labelSpan.textContent = inner ? inner.textContent.trim() : checkedInput.value;
  }

  function showSampleLimitModal() {
    const modal = document.getElementById('sample-limit-modal');
    if (modal) modal.classList.remove('hidden');
  }

  const modal = document.getElementById('sample-limit-modal');
  if (modal) {
    const closeBtn = modal.querySelector('#close-sample-modal');
    const overlay = modal.querySelector('.sample-modal__overlay');
    const closeModal = () => modal.classList.add('hidden');
    closeBtn?.addEventListener('click', closeModal);
    overlay?.addEventListener('click', closeModal);
  }

  if (localStorage.getItem('openCartAfterReload') === 'true') {
    localStorage.removeItem('openCartAfterReload');
    const cartIcon = document.querySelector('#cart-icon-bubble');
    cartIcon?.click();
  }

  document.querySelectorAll('input[name="Color"]').forEach(input => {
    input.checked = false;
  });

  const swatches = document.querySelectorAll('label.variant-option-Color');
  const selectedSwatches = new Set();

  if (swatches.length === 0) return;

  swatches.forEach((swatchLabel) => {
    swatchLabel.addEventListener('click', function (e) {
      if (e.target.closest('.icon-eye-view')) return;

      const inputId = swatchLabel.getAttribute('for');
      const input = document.getElementById(inputId);
      if (!input || input.disabled) return;

      const variantId = input.dataset.variantId;
      if (!variantId) return;

      if (swatchLabel.classList.contains('is-selected')) {
        swatchLabel.classList.remove('is-selected');
        selectedSwatches.delete(variantId);
      } else {
        if (selectedSwatches.size >= maxSamples) {
          showMessage('You can select up to three samples per customer.', 'error');
          showSampleLimitModal();
          return;
        }
        swatchLabel.classList.add('is-selected');
        selectedSwatches.add(variantId);
      }

      updateSelectedSampleLabels();
    });
  });

  const defaultBtn = document.querySelector('.product-form__submit');
  if (defaultBtn) {
    defaultBtn.style.display = 'none';

    const customBtn = document.createElement('button');
    customBtn.type = 'button';
    customBtn.textContent = 'Add Free Samples';
    customBtn.className = defaultBtn.className + ' custom-sample-submit';
    defaultBtn.parentNode.appendChild(customBtn);

    customBtn.addEventListener('click', async () => {
      if (selectedSwatches.size === 0) {
        showMessage('Please select up to three free samples.', 'error');
        return;
      }

      showMessage('Adding samples to cart...', 'info');

      try {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();

        const existingSampleCount = cartData.items.filter(item => item.properties?.Sample === 'true').length;

        if (existingSampleCount >= maxSamples) {
          showMessage('You can select up to three samples per customer.', 'error');
          showSampleLimitModal();
          return;
        }

        const availableSpots = maxSamples - existingSampleCount;
        const swatchesToAdd = Array.from(selectedSwatches).slice(0, availableSpots);

        if (swatchesToAdd.length === 0) {
          showMessage('You can select up to three samples per customer.', 'error');
          showSampleLimitModal();
          return;
        }

        // _source: ordered from the sample PDP itself (vs the product-page CTA which sets
        // _source: Product page). _vehicle: the shopper's garage YMM, when set. Hidden props.
        const baseProps = { Sample: 'true', _source: 'Sample page' };
        const g = window.NewarkYMM && NewarkYMM.getVehicle();
        if (g && g.make) baseProps._vehicle = NewarkYMM.label(g);

        const items = swatchesToAdd.map(variantId => ({
          id: variantId,
          quantity: 1,
          properties: { ...baseProps }
        }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (res.ok) {
          localStorage.setItem('openCartAfterReload', 'true');
          location.reload();
        } else {
          showMessage('There was a problem adding your samples. Please try again.', 'error');
        }

      } catch {
        showMessage('Unexpected error. Please try again later.', 'error');
      }
    });
  }

  updateSelectedSampleLabels();
  updateSelectedMaterialLabel();

  document.querySelectorAll('fieldset.fieldset-Material input[type="radio"]').forEach(input => {
    input.addEventListener('change', updateSelectedMaterialLabel);
  });
});
